import { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { AxiosError } from 'axios'

import { getContestInfo } from '@/services/contest'
import { errorBoundary } from '@/services/errorBoundary'

import { ErrorCodes } from '@/enums'

export const useContestInfo = (contestId: UUID) => {
  const history = useHistory()
  const result = useQuery({
    queryKey: ['contest', contestId],
    queryFn: () => getContestInfo(contestId),
  })

  useEffect(() => {
    if (
      (result?.error as AxiosError)?.response?.status === ErrorCodes.NotFound
    ) {
      history.replace(`/discover`)
    }
    errorBoundary(result?.error)
  }, [contestId, result?.error, history])

  return result
}
